<div id="home-factoring" class="container px-4">
  <div class="row">
    <div class="col-12 col-lg-5 ps-3 ps-lg-4  border-linea border-radius-2 border-secondary-factoring-600">
      <p class="primary-800 tabs">SEGO <span class="secondary-factoring-500">Factoring</span></p>
      <h1 class="primary-900">Invierte en las <br>mejores facturas</h1>
    </div>
    <div class="col-12 col-lg-7 gx-0 d-flex flex-column justify-content-end">
      <p class="p2-medium neutral-500 my-2">
        Invierte con SEGO Factoring y obtén <strong class="p2-bold">rentabilidades de hasta un 11,5%
          anual</strong>.
      </p>
      <div class="link-container mb-2">
        @if (isPlatformFactoring) {
        <a id="home-factoring-claves" routerLink="/como-funciona"
          class="link1-bold primary-900 d-flex align-items-center" title="Saca partido al adelanto de facturas">
          <span class="me-1 d-flex">Saca partido al adelanto de facturas</span>
          <span class="material-symbols-outlined">arrow_forward</span>
        </a>
        }
        @if (!isPlatformFactoring) {
        <a id="home-factoring-claves" href="{{domainUrl + '/como-funciona'}}"
          class="link1-bold primary-900 d-flex align-items-center" title="Saca partido al adelanto de facturas">
          <span class="me-1 d-flex">Saca partido al adelanto de facturas</span>
          <span class="material-symbols-outlined">arrow_forward</span>
        </a>
        }
      </div>
    </div>
    <div class="col-12 mt-3 s-mb-24 bg-primary-100 border-radius-4 p-2">
      <div class="mx-3 mx-lg-4">
        <p class="p3-regular neutral-900">Producto ofrecido por Smart and Small SL. No sujeto al
          Reglamento (UE) 2020/1503 del Parlamento Europeo y por tanto, no está supervisado por CNMV.</p>
      </div>
    </div>
  </div>

  @if (isLoading) {
  <div class="mt-5 p-5">
    <app-is-loading [color]="'factoring'"></app-is-loading>
  </div>
  }

  @if (!isLoading && oportunidadFactoring) {
  <div class="row">
    <div class="col-12 px-0">
      <app-ficha-una-oportunidad [oportunidad]="oportunidadFactoring" [isLogged]="isLogged"></app-ficha-una-oportunidad>
    <div class="text-center s-mt-24">
        @if (isPlatformFactoring) {
          <app-btn-link [linkTitle]="'Ver nuestras oportunidades'" 
            [linkUrl]="'/oportunidades-inversion'"></app-btn-link>
        }@else {
          <app-btn-link [linkTitle]="'Ver nuestras oportunidades'" [linkType]="'href'"
            [linkUrl]="domainUrl + '/oportunidades-inversion'"></app-btn-link>
        }
    </div>
    </div>
  </div>
  }

  @if (!isLoading && !oportunidadFactoring) {
      <app-subiendo-oportunidades [line]="'factoring'"></app-subiendo-oportunidades>
  }

</div>